export default __webpack_public_path__ + "static/media/Consecrated Do Kki.88b69494.jpg";